/* eslint-disable no-console */

import { register } from 'register-service-worker';
import { store } from '@/store';
import { nonDebugLog } from './util-functions/initialization-utils';

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}firebase-messaging-sw.js`, {
    ready() {
      nonDebugLog(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      );
    },
    registered(registration) {
      nonDebugLog('Service worker has been registered.');
      store.commit('serviceWorkerRegistation', registration);
    },
    cached() {
      nonDebugLog('Content has been cached for offline use.');
    },
    updatefound() {
      nonDebugLog('New content is downloading.');
    },
    updated() {
      nonDebugLog('New content is available; please refresh.');
    },
    offline() {
      nonDebugLog('No internet connection found. App is running in offline mode.');
    },
    error(error) {
      console.error('Error during service worker registration:', error);
    },
  });
}
